import * as THREE from 'three';

// Smoke Class
// By Marco Biedermann https://codepen.io/marcobiedermann/pen/jympXQ
export class Smoke {
    constructor(options) {
        const defaults = {
            width: window.innerWidth,
            height: window.innerHeight,
            color: 0xffffff,
            opacity: 0.6,
            density: 50,
            smokeImg: "/wp-content/themes/lab-sek/dist/images/clouds.png"
        };

        Object.assign(this, defaults, options);
        this.onResize = this.onResize.bind(this);

        this.addEventListeners();
        this.init();
    }

    init() {
        const { width, height, color } = this;

        this.clock = new THREE.Clock();

        const renderer = (this.renderer = new THREE.WebGLRenderer({ alpha: true }));

        renderer.setSize(width, height);

        this.scene = new THREE.Scene();


        const meshGeometry = new THREE.BufferGeometry(200, 200, 200);
        const meshMaterial = new THREE.MeshLambertMaterial({
            color: 0x000000,
            wireframe: false
        });
        this.mesh = new THREE.Mesh(meshGeometry, meshMaterial);

        this.cubeSineDriver = 0;

        this.addCamera();
        this.addLights();
        this.addParticles();

        document.getElementById('smoke-bg').appendChild(renderer.domElement);

    }

    evolveSmoke(delta) {
        const { smokeParticles } = this;

        let smokeParticlesLength = smokeParticles.length;

        while (smokeParticlesLength--) {
            smokeParticles[smokeParticlesLength].rotation.z += delta * 0.2;
        }
    }

    addLights() {
        const { scene } = this;
        const light = new THREE.DirectionalLight(0xffffff, 3.75);

        light.position.set(-1, 0, 1);
        scene.add(light);
    }

    addCamera() {
        const { scene } = this;
        const camera = (this.camera = new THREE.PerspectiveCamera(
            75,
            this.width / this.height,
            1,
            10000
        ));

        camera.position.z = 1000;
        scene.add(camera);
    }

    addParticles() {
        const { scene, color, opacity, density, smokeImg } = this;

        const textureLoader = new THREE.TextureLoader();
        const smokeParticles = (this.smokeParticles = []);

        textureLoader.load(
            smokeImg,
            (texture) => {
                const smokeMaterial = new THREE.MeshLambertMaterial({
                    color: color,
                    map: texture,
                    opacity: opacity,
                    transparent: true
                });
                smokeMaterial.map.minFilter = THREE.LinearFilter;
                const smokeGeometry = new THREE.PlaneGeometry(350, 350);

                const smokeMeshes = [];
                let limit = density;

                while (limit--) {
                    smokeMeshes[limit] = new THREE.Mesh(
                        smokeGeometry,
                        smokeMaterial
                    );
                    smokeMeshes[limit].scale.set(1.5, 1.5, 1.5);
                    smokeMeshes[limit].position.set(
                        Math.random() * 1000 - 150,
                        Math.random() * 1000 - 750,
                        Math.random() * 1000 - 100
                    );
                    smokeMeshes[limit].rotation.z = Math.random() * 360;
                    smokeParticles.push(smokeMeshes[limit]);
                    scene.add(smokeMeshes[limit]);
                }
            }
        );
    }

    render() {
        const { mesh } = this;
        let { cubeSineDriver } = this;

        cubeSineDriver += 0.01;

        mesh.rotation.x += 0.005;
        mesh.rotation.y += 0.01;
        mesh.position.z = 100 + Math.sin(cubeSineDriver) * 500;

        this.renderer.render(this.scene, this.camera);
    }

    update() {
        this.evolveSmoke(this.clock.getDelta());
        this.render();

        requestAnimationFrame(this.update.bind(this));
    }

    onResize() {
        const { camera } = this;

        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        camera.aspect = windowWidth / windowHeight;
        camera.updateProjectionMatrix();

        this.renderer.setSize(windowWidth, windowHeight);
    }

    addEventListeners() {
        window.addEventListener("resize", this.onResize);
    }
}
